export function TableActions({ children }: { children: React.ReactNode }) {
	return <div className="ml-auto flex gap-2.5 items-center">{children}</div>;
}
